import 'css-chunksrc/client/scenes/workloads/wbs/event/dateForm/styles.scss';export default {
  "dateForm": "_dateForm_zhrrv_1",
  "input": "_input_zhrrv_5",
  "readOnly": "_readOnly_zhrrv_12",
  "disabled": "_disabled_zhrrv_18"
};